module.exports = __webpack_public_path__ + "img/td.f37a395c.svg";